<template>
  <NotificationBar ref="notificationBar"/>
  <!-- <UserBarVue
   :loginCb="() => fetchOrderPageInfo()"
  /> -->

  <div v-if="showModal" class="modal">
    

    <!-- USER LOGIN SUBMODAL -->
    <!-- ------------------- -->
    <div v-if="showUserLogin" class="modal-content FCNW">
      <div class="close-btn-wrapper">
        <CloseBtnVue
          :closeFunc="toggleLoginModal"
        />
      </div>
      <h4>Log into Account</h4>
      <input type="text" v-model="userEmail" placeholder="email address">
      <input type="password" v-model="userPw" placeholder="user password">
      <div>
        <ModernButtonVue
          :btnText="'Login'"
          :clickFunc="userLogin"
          :disabled="!canLoginUser"
          :btnSize="'small'"
          :showBorder="true"
        />
      </div>
    </div>
    <!-- ------------------- -->


    <!-- GUEST LOGIN SUBMODAL -->
    <!-- -------------------- -->
    <div v-if="showGuestLogin" class="modal-content FCNW">
      <div class="close-btn-wrapper">
        <CloseBtnVue
          :closeFunc="() => toggleGuestModal( true )"
        />
      </div>
      <h4>{{ (Object.keys(userInfo || {}).length) ? 'Order Info (User)' : 'Order Info (Guest)'}}</h4>
      <div class="guest-login-wrapper">
        <div>
          <input v-model="checkoutUserInfo.firstName" type="text" name="first-name" placeholder="First name" required>
          <span>*</span>
        </div>
        <div>
            <input v-model="checkoutUserInfo.lastName" type="text" name="last-name" placeholder="Last name" required>
            <span>*</span>
        </div>
        <div>
          <input v-model="checkoutUserInfo.email" type="email" name="email" placeholder="Email" required>
          <span>*</span>
        </div>
        <div>
          Address only required if shipping negatives.
        </div>
        <div>
          <input v-model="checkoutUserInfo.address.street" type="text" name="street-number-name" placeholder="Street number/name">
        </div>
        <div>
          <input v-model="checkoutUserInfo.address.apartmentNumber" type="text" name="apartment-number" placeholder="Apartment number">
        </div>
        <div>
          <input v-model="checkoutUserInfo.address.city" type="text" name="city" placeholder="City">
        </div>
        <div>
          <input v-model="checkoutUserInfo.address.state" type="text" name="state" placeholder="State">
        </div>
        <div>
          <input v-model="checkoutUserInfo.address.zipCode" type="text" name="zip-code" placeholder="Zip code">
        </div>
      </div>
      <ModernButtonVue
        :btnSize="'small'"
        :btnText="'Continue to Payment'"
        :disabled="!canContinueFromGuest"
        :clickFunc="togglePaymentModal"
        :showBorder="true"
      />
    </div>
    <!-- -------------------- -->


    <!-- FOR PAYMENT PORTION OF MODAL -->
    <!-- ---------------------------- -->
    <div v-if="showPaymentModal" class="modal-content FCNW">
      <div class="close-btn-wrapper">
        <CloseBtnVue
          :closeFunc="() => togglePaymentModal()"
        />
      </div>


      <!-- IF LAB IS NOT PLACING ITS OWN ORDER -->
      <!-- ----------------------------------- -->
      <div v-if="!isViewOnly">
        <div class="bold">
          {{ `Sub Total $: ${shoppingCart.totalCostDollars?.toFixed(2)}` }}
        </div>
        <div class="bold" style="margin-bottom: 1rem;">
          {{ `Tax $: ${shoppingCart.taxDollars?.toFixed(2)}` }}
        </div>
        <div>
          <SquarePaymentsVue
            :labOptionsId="labOptions._id"
            :shoppingCart="shoppingCart"
            :showNotificationCb="(data) => showNotificationCb(data)"
            :userId="userInfo._id"
            :checkoutUserInfo="checkoutUserInfo"
            :resetDataCb="resetDataCb"
            :applicationId="aesDecrypt( labOptions.squareApplicationId )"
            :isLab="isViewOnly"
          />
        </div>
      </div>
      <!-- ----------------------------------- -->

      <!-- IF USER IS PLACING ORDER -->
      <!-- ------------------------ -->
      <div 
        v-else 
        style="min-height: 5rem; justify-content: center;" 
        class="FCNW"
      >
        <ModernButtonVue
          :btnText="'Submit internal order'"
          :clickFunc="submitInternalOrder"
          :btnSize="'small'"
          :showBorder="true"
        />

      </div>
      <!-- ------------------------ -->

    </div>
    <!-- ---------------------------- -->



  </div>

  <div id="invalid-modal" v-if="labCannotBeFound">
    <h1>Lab cannot be found.</h1>
  </div>

  <!-- TODO SHOW PAGE IS VIEW ONLY - THIS SHOULD ONLY BE IF LOGGED IN AS THE LAB -->
  <div v-else id="lab-order-container" class="FCNW">
    <h1 v-if="isViewOnly" style="color:red">
      PAGE IS VIEW ONLY - CANNOT PLACE ORDER
    </h1>
    <h1 id="no-orders" v-if="!canPlaceOrder" style="color:red">
      {{ 
        (!labOptions.labIsTakingOrders) 
          ? 'Lab is not currently taking orders.'
          : 'Lab Payment options are not set up. Cannot place order.'
      }}
    </h1>


    <h1>Create a new order with {{ labOptions.labName }}</h1>

    <!-- USE THIS SECTION TO TRACK WHAT IS IN THE CART -->
    <div 
      id="shopping-cart-icon-wrapper"
    >
      <div 
        id="shopping-cart-icon" 
        @click="toggleCartView()"
        :class="{ highlight: !!shoppingCartBtnHighlight }"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-cart" viewBox="0 0 16 16">
          <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l1.313 7h8.17l1.313-7zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
        </svg>
        <div style="padding-left: 10px;">
          {{ (shoppingCart?.itemList?.length) ? shoppingCart?.itemList?.length : '0' }}
        </div>
  
      </div>
      <div id="shopping-cart-div" v-if="cartVisible">
        <h3>Shopping Cart</h3>
        <div id="item-list-wrapper">
          <div 
            v-for="(line, index) in shoppingCart.itemList"
            :key="index"
            class="line-item"
          >

            <div 
              v-for="[key, val] of Object.entries(line.itemDetails)"
              :key="key"
              class="sub-line-item FRNW"
            >
              <div class="right"><strong>{{ `${ separateWords(key)}: ` }}</strong></div>
              <div class="left">{{ `${val.optionText} - ($${val.costDollars})` }}</div>
            </div>
            <div class="sub-line-item FRNW">
              <div style="text-align: right;"><strong>{{ `Qty: ` }}</strong></div>
              <div style="text-align: left;">{{ `${line.qty || 0}` }}</div>
            </div>
            <div>
              <ModernButtonVue
                :btnSize="'extra-small'"
                :btnText="'Remove'"
                :clickFunc="()=> removeItem(index)"
                :showBorder="true"
                :backgroundColor="'rgb(198, 132, 132)'"
              />
            </div>

          </div>
        </div>

        <div id="return-option-div">
          <label style="margin-right: .25rem;">
            <b>Negative Return Option:</b>
          </label>
          <select 
            v-model="shoppingCart.negReturnDetails.type"
            @change="computeCartTotal()"
          >
            <option value="">----</option>
            <option value="na">N/A ($0)</option>
            <option 
              v-for="option in negativeReturnOptions"
              :key="option"
              :value="option"
            >
              {{ computeNegOptionText(option) }}
            </option>
          </select>

        </div>

        <div id="total-div"> 
          <div><strong>Total: </strong> ${{ shoppingCart.totalCostDollars }} </div>
          <InfoVue
            :title="'Note: tax and shipping may be added at checkout.'"
          />
        </div>

        <div class="btn-bar" v-if="!userLoggedIn">
          <button @click="toggleLoginModal">
            Login
          </button>


          <button 
            @click="() => toggleGuestModal()"
            :disabled="!shoppingCart.itemList.length"
          >
            Continue as Guest
          </button>
        </div>

        <div class="btn-bar" v-else>
          <ModernButtonVue
            :clickFunc="logOutUser"
            :btnSize="'extra-small'"
            :btnText="'Logout'"
            :showBorder="true"
          />
          <ModernButtonVue
            :clickFunc="toggleGuestModal"
            :disabled="!shoppingCart.itemList.length || !shoppingCart.negReturnDetails.type"
            :btnSize="'extra-small'"
            :btnText="'Continue'"
            :showBorder="true"
          />
        </div>

      </div>
    </div>

    <!-- SECTION FOR SELECTING OPTIONS -->
    <div
      class="FRNW" 
      style="
        justify-content: space-evenly; 
        flex: 1; 
      "
    >

      <!-- SECTION FOR LAB INFO -->
      <div id="lab-info-wrapper" class="FCNW">

        <div id="picture-div">
          <!-- DEFAULT LOGO -->
          <img  v-if="!labOptions?.labLogo?.presignedUrl" src="../../public/defaultLabPicture.jpg" alt="default image">

          <!-- CUSTOM LOGO -->
          <img v-else :src="labOptions.labLogo.presignedUrl" :alt="labOptions.labLogo.fileName">
        </div>

        <div>
          <h2>{{ labOptions.labName }}</h2>
        </div>

        <div>
          <p>{{ labOptions.aboutString }}</p>
        </div>

      </div>
      
      <div 
        id="lab-options-wrapper" 
        style="font-weight: bold;"
      >
        <div id="logged-in-div">Logged in as {{ loggedInName }}</div>
        <div>Select order options below:</div>

        <!-- GENERAL LAB OPTIONS -->
        <div
          v-for="[key, title] of Object.entries(labOptionsArrayMap)"
          :key="key"
          class="FRNW sub-line-item"

        >
          <div class="right">{{ title }}</div>
          <div class="left">
            <select :name="key" id="" class="option-selectors" >
              <option 
                v-for="option of labOptions[key]"
                :key="option._id"
                :value="JSON.stringify( option )"
              >
                {{ option.optionText + ` - ($${option.costDollars})` }}
              </option>
            </select>
          </div>
        </div>
        <div class="FCNW">
          <div class="FRNW sub-line-item">
            <div class="right">
              Qty:
            </div>
            <div class="left">
              <input 
                type="number" 
                placeholder="Number of this item" 
                v-model="lineQty"
              >
            </div>
          </div>
          
          <div>
            <ModernButtonVue
              :btnSize="'extra-small'"
              :btnText="'Add to Cart'"
              :showBorder="true"
              :clickFunc="addToCart"
            />
          </div>
        </div>
      </div>
      
    </div>

    <div 
      id="footer"
      @click="goToHomePage" 
      style="cursor: pointer; margin: .25rem 0;"
      title="Go to Film Lab Assistant home page to learn more."
    >
      Powered by Film Lab Assistant
    </div>

  </div>

</template>


<script>
import NotificationBar from '@/components/NotificationBar.vue';
import CloseBtnVue from '@/components/basicComponents/CloseButton.vue';
import ModernButtonVue from '@/components/basicComponents/ModernButton.vue';
import SquarePaymentsVue from '@/components/SquarePayment.vue';
import UserBarVue from '@/components/basicComponents/UserBar.vue';
import InfoVue from '@/components/basicComponents/Info.vue';

import { useRoute } from 'vue-router';
import { SeparateWords, ValidateEmail, AesDecrypt, RemoveLocalStorageKeys, LocalStorageFuncs } from '../utils';


import router from '../router/index';
const API = process.env.VUE_APP_API_URL;
let NOTIFICATION, FLA_AXIOS;


export default {
  name: 'NewOrderPage',
  components: {
    NotificationBar,
    CloseBtnVue,
    ModernButtonVue,
    SquarePaymentsVue,
    UserBarVue,
    InfoVue,
  },
  props: {},
  data() {
    return {
      labId: null,
      labOptions: {},
      labOptionsArrayMap: {},
      labUserInfo: {},
      userInfo: {},

      // cart info
      cartVisible: false,
      lineQty: 1,
      shoppingCart: {
          // userId: 'this is for the user who is placing the order',
          // itemList: [{
          //   itemTotal: this is the line total as a Number,
          //    itemDetails: { this is the object with all the line details }
          //    qty: number of this line item
          // }],
          // totalCostDollars: Number
        userId: '',
        itemList: [],
        negReturnDetails: {
          totalCost: 0,
          type: '',
        },
        totalCostDollars: 0,
      },

      // for user login modal
      showUserLogin: false,
      userEmail: '',
      userPw: '',

      // for guest login modal
      showGuestLogin: false,
      checkoutUserInfo: {
        firstName: '',
        lastName: '',
        email: '',
        address: {
          street: '',
          apartmentNumber: '',
          city: '',
          state: '',
          zipCode: '',
        },
      },

      // for payments
      showPaymentModal: false,
      
      shoppingCartBtnHighlight: 0,
    }
  },
  computed: {
    userLoggedIn() {
      return !!Object.keys(this.userInfo)?.length;
    },

    showModal() {
      return (
        this.showUserLogin ||
        this.showGuestLogin ||
        this.showPaymentModal
      );
    },

    canLoginUser() {
      return this.userPw !== '' && ValidateEmail( this.userEmail );
    },

    canContinueFromGuest() {
      // make sure valid first and last name, email and lab is set up to take orders.

      // check that lab has valid access tokens for square
      // TODO: if adding a new payment method will need to add more tokens to the list
      return (
        this.checkoutUserInfo.firstName &&
        this.checkoutUserInfo.lastName &&
        ValidateEmail( this.checkoutUserInfo.email ) &&

        this.labOptions?.labIsTakingOrders &&

        // need to decrypt these values
        AesDecrypt(this.labOptions?.squareAccessToken)[1] &&
        AesDecrypt(this.labOptions?.squareApplicationId)[1]
      );
    },

    // Used so labs can view what their page will look like.
    isViewOnly() {
      return this.userInfo?._id === this.labUserInfo._id;
    },

    labCannotBeFound() {
      return !Object.keys( this.labOptions || {} )?.length;
    },

    loggedInName() {
      const isLoggedIn = this.userInfo.firstName;
      return ( isLoggedIn ) 
        ? `${this.userInfo.firstName} ${this.userInfo.lastName}`
        : 'guest';
    },

    canPlaceOrder() {
      return (
        this.labOptions?.labIsTakingOrders &&

        AesDecrypt(this.labOptions?.squareAccessToken)[1] &&
        AesDecrypt(this.labOptions?.squareApplicationId)[1]
      );
    }
  },
  methods: {

    fetchOrderPageInfo() {      
      const data = { 
        labId: this.labId,
        userId: LocalStorageFuncs.fetchUserId(),
      };

      FLA_AXIOS('post', API + '/api/labOptions/fetchOrderPageInfo', data)
      .then( res => {
        NOTIFICATION.showNotification( res.data );
        const { labUserInfo, labOptions, userInfo } = res.data;
        this.labUserInfo = labUserInfo;
        this.userInfo = userInfo || {};
        this.labOptions = labOptions;

        // need to have labOptions before fetching return options
        this.fetchNegativeReturnOptions();
      } )
      .catch( e => console.error(e) );
    },

    fetchLabOptionsArrayMap() {
      FLA_AXIOS('get', API + '/api/labOptions/labOptionsArrayMap' )
        .then( res => {
          const { labOptionsArrayMap } = res.data;
          this.labOptionsArrayMap = labOptionsArrayMap;
        } )
        .catch( e => console.error(e) );
    },

    fetchNegativeReturnOptions() {
      FLA_AXIOS('get', API + '/api/order/negativeReturnOptions')
      .then( res => {
        const { negativeReturnOptions } = res.data;

        // filter out ship option as needed
        const options = this.labOptions?.willShipNegatives
          ? negativeReturnOptions
          : negativeReturnOptions
              .filter( x => !x.toLowerCase().includes('ship') );

        this.negativeReturnOptions = options;
      } )
      .catch( e => console.error( e ) )
    },

    toggleCartView() {
      this.cartVisible = !this.cartVisible
    },

    separateWords( str ) {
      return SeparateWords( str );
    },

    toggleLoginModal() {
      this.showUserLogin = !this.showUserLogin;
      if ( this.showUserLogin ) {
        // this means we are showing it
        window.ShowBackdrop( true );
      }
      else {
        window.HideBackdrop( true );
      }
    },

    clearCheckoutUserInfo() {
      // address
      [ 'street', 'apartmentNumber', 'city', 'state', 'zipCode']
        .forEach( x => this.checkoutUserInfo.address[x] = '' );

      // other guest fields
      [ 'firstName', 'lastName', 'guestEmail' ]
        .forEach( x => this.checkoutUserInfo[x] = '' );
    },

    toggleGuestModal( forceClose=false ) {
      if ( forceClose ) {
        this.showGuestLogin = false;
        window.HideBackdrop( true );
        // this.clearCheckoutUserInfo();
        return;
      }
      this.calculateCartTotal();
      this.showGuestLogin = !this.showGuestLogin;

      if ( !this.showGuestLogin ) {
        // clear fields
        // this.clearCheckoutUserInfo();
      }
      else {

        // pull info from userInfo
        if ( Object.keys( this.userInfo || {}).length ) {
          // const { firstName, lastName, email, address } = this.userInfo;
          this.checkoutUserInfo = this.userInfo;

        }
        
        window.ShowBackdrop( true );
      }
    },

    togglePaymentModal() {
      this.showPaymentModal = !this.showPaymentModal;
      if ( this.showPaymentModal ) {
        this.showGuestLogin = false;
        window.ShowBackdrop( true );
      }
      else {
        window.HideBackdrop( true );
      }
    },

    // // OLD METHOD
    // submitOrder() {
    //   NOTIFICATION.showNotification( { notification: {
    //     msg: 'Order submition not implemented.',
    //     type: 'error'
    //   } } );

    //   const data = {
    //     labId: this.labId,
    //     labOptionsId: this.labOptions._id,
    //     userId: this.userInfo._id,
    //     shoppingCart: this.shoppingCart,
    //   };

    //   FLA_AXIOS('post', API + '/api/order/create', data)
    //   .then( res => {
    //     console.log(res.data)
    //     // TODO: if successful toggle payment modal
    //   })
    //   .catch( e => console.log(e) )
    // },

    userLogin() {
      const data = {
        email: this.userEmail,
        pw: this.userPw,
      };

      FLA_AXIOS('post', API + '/api/user/login', data )
        .then( res => {

          const { userName, FLA_token, FLA_u_id } = res.data;
          if ( userName ) this.userName = userName;
          NOTIFICATION.showNotification( res.data );

          // set storage items
          LocalStorageFuncs.setUserId( FLA_u_id );
          LocalStorageFuncs.setToken( FLA_token );

          // reset input info
          if ( res.data?.notification?.type !== 'error' ) {
            this.email = '';
            this.pw = '';
            this.toggleLoginModal();
            this.fetchOrderPageInfo();
          }
        } )
        .catch( e => console.error(e) );
    },

    showNotificationCb( data ) {

      // because showNotification is meant to be used in a thenable or a try catch this will cause a thown error that is not caught. There is probably a better way to do this.
      try {
        NOTIFICATION.showNotification( data )
      } 
      catch (error) {}
    },

    // used as a CB when submitting an order
    resetDataCb() {
      // reset shopping cart
      this.shoppingCart.itemList = [];
      this.shoppingCart.totalCostDollars = 0;

      // reset flags
      this.toggleGuestModal( true );
      if ( this.showPaymentModal === true ) {
        this.togglePaymentModal();
      }

      // hide cart
      this.cartVisible = false;
    },

    openCreateAccountPage() {
      router.push('/createUser')
    },

    goToHomePage() {
      router.push('/')
    },

    async logOutUser() {

      //checkoutUserInfo
      this.checkoutUserInfo = {
        firstName: '',
        lastName: '',
        email: '',
        address: {
          street: '',
          apartmentNumber: '',
          city: '',
          state: '',
          zipCode: '',
        },
      };

      this.userInfo = {};

      // // clear cookies
      // // not needed since data is not stored in cookies
      // await FLA_AXIOS('post', API + '/api/user/logout');

      // clear local variables
      RemoveLocalStorageKeys();

      // force a notification
      NOTIFICATION.showNotification( { notification: {
        msg: 'User has been logged out.'
      } } );

    },

    submitInternalOrder() {
      const data = {
        labOptionsId: this.labOptions._id,
        shoppingCart: this.shoppingCart,
        userId: this.userInfo._id,
        checkoutUserInfo: this.checkoutUserInfo,
      };
      FLA_AXIOS('post', API + '/api/order/createPaymentSquare', data)
      .then( res => {
        NOTIFICATION.showNotification( res.data );
        this.resetDataCb();
      })
      .catch( e => console.error(e) )
    },

    computeNegOptionText( option ) {
      const isShipping = option.toLowerCase().includes('ship');

      if ( isShipping ) {
        const { shipNegativesCostPerItem, shipNegativesCostDollars } = this.labOptions;

        let ret = `${option} ($${shipNegativesCostDollars}`;

        ( shipNegativesCostPerItem ) 
          ? ret += ` / item)`
          : ret += ` / order)`;

        return ret;
      }
      else {
        return `${option} ($0)`;
      }
    },


    // cart manipulation
    // -----------------

    // looks at current selected options data and adds an item to the cart
    addToCart() {

      const qty = this.lineQty;

      // basic line item
      const line = {
        itemTotal: 0,
        itemDetails: {},
        qty,
      };

      // get options, value will be the object key, this seemed more simple than v-model and setting defaults
      const selectElements = document.getElementsByClassName('option-selectors');
      for ( const el of selectElements ) {

        const name = el.name;

        // get options for select tag
        const optionElements = el.getElementsByTagName('option');
        for ( const option of optionElements ) {
          if ( !option.selected ) continue;

          const value = JSON.parse( option.value );
          line.itemTotal += value.costDollars;
          line.itemDetails[name] = value;
        }
      }    

      this.shoppingCart.itemList.push( line );

      this.computeCartTotal();
      this.lineQty = 1;

      // highlight shopping cart btn
      this.highlightShoppingCartBtn();
    },

    highlightShoppingCartBtn() {
      // highlight shopping cart button
      this.shoppingCartBtnHighlight ++;

      // un-highlight after a second
      setTimeout(() => {
        this.shoppingCartBtnHighlight --;
      }, 1000);
    },

    removeItem( idx ) {
      this.shoppingCart.itemList.splice(idx, 1);
      this.computeCartTotal();

      // highlight shopping cart btn
      this.highlightShoppingCartBtn()
    },

    computeCartTotal() {
      const total = this.shoppingCart?.itemList?.map( x => x.itemTotal * x.qty ).reduce( (a,b) => a+b, 0);

      let shipTotal = 0
      const isShippingNegs = this.shoppingCart.negReturnDetails.type
        .toLowerCase()
        .includes('ship')
      if ( isShippingNegs && this.shoppingCart.itemList.length ) {
        const { shipNegativesCostPerItem, shipNegativesCostDollars } = this.labOptions;
        const t = ( shipNegativesCostPerItem ) 
          ? this.shoppingCart.itemList
              .map( item => item.qty )
              .reduce( (a,b) => a+b, 0 ) * shipNegativesCostDollars
          : shipNegativesCostDollars;
        shipTotal += t;
      }
      this.shoppingCart.totalCostDollars = total + shipTotal;
    },

    calculateCartTotal() {
      const data = {
        shoppingCart: this.shoppingCart,
        labOptionsId: this.labOptions._id
      };
      FLA_AXIOS('post', API + '/api/order/calculateCartTotals', data)
      .then( res => {
        const { totalCostDollars, taxDollars } = res.data;
        this.shoppingCart.totalCostDollars = totalCostDollars;
        this.shoppingCart.taxDollars = taxDollars || 0;
      } )
      .catch( e => console.error(e) );
    },

    aesDecrypt( string ) {
      const [ e, decryptedString ] = AesDecrypt( string );
      return decryptedString;
    },


    // -----------------


  },
  mounted() {
    const route = useRoute();
    const { labId } = route.query;

    NOTIFICATION = this.$refs.notificationBar;
    FLA_AXIOS = window.FLA_Axios;
    
    if ( !labId ) {
      // lets show some sort of error
      // force a notification
      NOTIFICATION.showNotification( { notification: {
        msg: 'An error occured. Return to previous page and try again.',
        type: 'error'
      } } );
      return;
    }
    this.labId = labId;

    // fetch lab info
    this.fetchOrderPageInfo();
    this.fetchLabOptionsArrayMap();
    
    window.HideBackdrop( true );

  },
}


</script>


<style scoped>

.line-item {
  border: 1px solid black;
  border-radius: 10px;
  background-color: rgba(218,208,197,255);
  background-color: #F8EDE3;
  /* background-color: #DFD3C3; */
  /* background-color: #cd8f81; */
  display: flex;
  flex-direction: column;
  margin-bottom: .5rem;
}

.sub-line-item {
  justify-content: space-around;
  align-items: center;
}

.sub-line-item div {
  width: calc( 50% - .5rem );
}

.left { text-align: left; }
.right { text-align: right; }

#shopping-cart-icon-wrapper {
  display: flex;
  flex-direction: row-reverse;
  /* cursor: pointer; */
  position: relative;
}

#shopping-cart-icon {
  display: flex;
  background-color: gainsboro;
  /* background-color: #cd8f81; */
  padding: .5rem;
  justify-content: center;
  align-content: center;
  justify-items: center;
  border: 1px solid black;
  border-radius: 10px;
  cursor: pointer;
  transition: all .3s;
}

#shopping-cart-div {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: calc( 24px + 16px + 4px);
  right: 0;
  padding: 10px;
  /* background-color: gainsboro; */
  /* background-color: #F8EDE3; */
  /* background-color: #cd8f81; */
  background-color: #DFD3C3;
  font-size: small;
  min-width: 50%;
  z-index: 10;
  overflow: auto;
  border-radius: 10px;
  border: 1px solid black;
}

#lab-options-wrapper, #lab-info-wrapper {
  width: 40%;
}

#picture-div img {
  width: 100%;
  max-width: 400px;
}

.btn-bar {
  display: flex;
  justify-content: space-evenly;
}
.btn-bar button { cursor: pointer; }

.modal {
  z-index: 55;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: baseline;
}

.modal-content{
  /* background-color: bisque; */
  background-color: gainsboro;
  padding: 1rem;
  margin: 2rem;
  border: 2px solid black;
  position: relative;
  border-radius: 10px;
  top: 15%;
}

.close-btn-wrapper {
  display: flex;
  flex-direction: row-reverse;
  position: absolute;
  top: 0rem;
  right: 0rem;
}

.guest-login-wrapper span{
  font-weight: bold;
  color: red;
}

.bold {
  font-weight: bold;
}

#total-div {
  display: flex;
  justify-content: center;
  align-items: center;
}

#item-list-wrapper {
  max-height: 25rem;
  margin: .5rem 0;
  overflow: auto;
}

.highlight {
  background-color: orange !important;
}

#invalid-modal {
  background-color: rgb(221, 118, 118);
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
}

#lab-order-container {
  height: 100%;
}

#logged-in-div {
  display: flex;
  margin: .25rem 0 1rem 0;
  justify-content: center;
  text-decoration: underline;
  background-color: var(--fla-gray);
  padding: .25rem;
  border-radius: var(--fla-border-radius);
}

</style>